
<template>
<div>
  <div class="overlay">
    <div class="top-text">
      <div class="wip-text">Work In Progress!</div>
    </div>
    <div class="it">
      <div class="itClass">
          <span class="heading"> <b> INCOME TAX DECLARATION </b> </span>
          <div class="it-description">
              <span> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
                  ut labore et dolore magna aliqua.
                  Ut enim ad min
              </span>
          </div>

      <div class="itBtn">
          <btn text="Label" type="primary" />
      </div>
    </div>
  </div>
</div>
</div>
</template>

<script>
export default {
    name: "IncomeTaxDeclaration",
    data() {
        return {
        }
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.itClass {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: auto 0px auto 0px;
    padding: 30px;
}
.heading {
        font-size: 22px;
        line-height: 1.09;
        text-align: center;
        color: #2c2c2c;
}
 .it-description {
        font-size: 13px;
        margin-top: 40px;
        font-weight: 600;
        line-height: 1.38;
        text-align: center;
        color: #606060;
    }
.itBtn {
    padding: 60px 50px;
}

.overlay {
  position: relative;
}

.top-text {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;
  z-index: 1;
}
.wip-text {
  font-family: Montserrat;
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  color: #444444;
  margin-top: 30%;
  transform: rotate(-45deg);
}
.it {
  position: relative;
}
</style>
